/**
 * IE11 support
 */
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import './util/why-did-you-render'

import React from 'react'
import ReactDOM from 'react-dom'

import { DEPLOYMENT_ENV } from './config'
import { DeploymentEnv } from '@enums/deployment-env'
import App from './App'
import { onPageLoad as reactAxeOnPageLoad } from './api/react-axe'
import { onPageLoad as segmentOnPageLoad } from './api/segment'
import { onPageLoad as sentryOnPageLoad } from './api/sentry'

import './index.css'
import { initI18n } from '@util/i18n/i18n'

// items used on window - for development/debugging only
declare global {
  interface Window {
    // AWS Amplify auth logs
    LOG_LEVEL: string
    // Cypress is available on window to conditionally do Cypress-only test
    // environment actions
    Cypress: object
    // stub out a Segment data clearing function for staging and local use
    segmentClearData: Function
  }
}

// coerce to DeploymentEnv type — intentionally blowing up the app if the val is null
const deploymentEnv = DEPLOYMENT_ENV as DeploymentEnv

if (!(deploymentEnv in DeploymentEnv)) {
  throw new Error(
    'DEPLOYMENT_ENV is not set. it must be set as an environment variable.'
  )
}

sentryOnPageLoad()
segmentOnPageLoad()
reactAxeOnPageLoad()
initI18n()

ReactDOM.render(<App />, document.getElementById('root'))
